import { mergeMap } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { IClientApiDependencySegment, catchApiError } from '@cbridge-packages/api';
import { createApiErrorNotification } from '@cbridge-packages/notification';
import { ServerAction } from '../server.action';
import { ServerTranslator } from '../server.translator';

type IDependencies = IClientApiDependencySegment;

export const createServerEpic: IEpic<{}, IDependencies> = (action$, _, dependencies) => action$.pipe(
  isTypeOfAndGetPayload(ServerAction.create.started),
  mergeMap((params) => {
    const { nodeId, reject } = params;

    return dependencies.api.createServer({ ...ServerTranslator.toApi(params), nodeId }).pipe(
      mergeMap((response) => {
        params.resolve?.(response);
        return [
          ServerAction.create.done({ params, result: response }),
        ];
      }),
      catchApiError((error) => {
        const isHandled = reject?.(error.errorCode, error.description, error.params);
        return [
          ServerAction.create.failed({ params, error: null }),
          ...(isHandled ? [] : [createApiErrorNotification(error)]),
        ];
      }),
    );
  }),
);
